import React from 'react';
import { makeAutoObservable } from 'mobx';
import { NavigateFunction } from 'react-router-dom';
import axios, { AxiosError } from 'axios';
import ScoReflectClient from './ScoReflectClient';
import UserStore from './UserStore';
import AuthStore from './auth/AuthStore';

class SettingsStore {
  private _photo: string | undefined;
  private _nickName: string | undefined;
  private _firstName: string | undefined;
  private _lastName: string | undefined;
  private _email: string | undefined;
  private _sex: number | undefined;
  private _birthday: string | undefined;

  public get photo(): string | undefined {
    return this._photo;
  }

  public set photo(value: string | undefined) {
    this._photo = value;
  }

  public get nickName(): string | undefined {
    return this._nickName;
  }

  public set nickName(value: string | undefined) {
    this._nickName = value;
  }

  public get firstName(): string | undefined {
    return this._firstName;
  }

  public set firstName(value: string | undefined) {
    this._firstName = value;
  }

  public get lastName(): string | undefined {
    return this._lastName;
  }

  public set lastName(value: string | undefined) {
    this._lastName = value;
  }
  
  public get email(): string | undefined {
    return this._email;
  }

  public set email(value: string | undefined) {
    this._email = value;
  }

  public get birthday(): string | undefined {
    return this._birthday;
  }

  public set birthday(value: string | undefined) {
    this._birthday = value;
  }

  public get sex(): number | undefined {
    return this._sex;
  }

  public set sex(value: number | undefined) {
    this._sex = value;
  }

  constructor() {
    makeAutoObservable(this);
  }

  public async update(navigate: NavigateFunction) {
    try {
      const data = new FormData();
      data.append("NickName", this._nickName ?? '');
      data.append("FirstName", this._firstName ?? '');
      data.append("LastName", this._lastName ?? '');
      //data.append("Email", this._email ?? '');
      data.append("Sex", this._sex?.toString() ?? '');

      const inputFile = document.getElementById("photoFile") as HTMLInputElement;
      if (inputFile.files && inputFile.files.length > 0)
        data.append("Photo", inputFile.files[0]);
  
      const response = await axios.post(
        "https://scoreflect.ru/api/v1/user/update",
        data,
        {
          headers: {
            'Content-Type': `multipart/form-data`
          },
          withCredentials: true
        }
      );

      if (response.status === 200) {
        AuthStore.refresh();
        navigate('/profile');
      }
      console.log(response)
    } catch (e) {
      if (e instanceof AxiosError) {
        if (e.status && e.status === 401) {
          await AuthStore.refresh();
          this.update(navigate);
        }
      }
      console.log(e)
    }
  }

  public onChangeEmail = (e: React.ChangeEvent<HTMLInputElement>) => {
    this._email = e.target.value;
  }

  public onChangeFirstName = (e: React.ChangeEvent<HTMLInputElement>) => {
    this._firstName = e.target.value;
  }

  public onChangeLastName = (e: React.ChangeEvent<HTMLInputElement>) => {
    this._lastName = e.target.value;
  }

  public onChangeNickName = (e: React.ChangeEvent<HTMLInputElement>) => {
    this._nickName = e.target.value;
  }
}

// eslint-disable-next-line
export default new SettingsStore();